<template>
  <section class="section cms-text-columns">
    <b-container>
      <div class="cms-text-columns__card">
        <b-row>
          <b-col
            v-for="(column, column_index) in columns"
            :key="`cms-column-${column_index}`"
            sm="6"
            lg="3"
          >
            <div class="cms-text-columns__item">
              <div v-if="column.icon" class="cms-text-columns__icon">
                <vb-icon :name="column.icon" :dotted="true" />
              </div>
              <div
                v-if="column.title"
                class="cms-text-columns__title h6"
                v-html="column.title"
              ></div>
              <div
                v-if="column.text"
                class="cms-text-columns__text"
                v-html="column.text"
              ></div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </section>
</template>

<script>
  /**
   * CMS `text-columns` block: grid of icon + title + text columns.
   * Schema (props): `{ columns: [{ icon, title, text }] }`.
   * Mirrors the original library/blocks/point-list-01.vue component.
   */
  export default {
    name: 'text-columns',

    props: {
      columns: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cms-text-columns {
    &__card {
      background: $white;
      border-radius: $border-radius-lg * 2;
      padding: $grid-gutter-width;
    }

    &__item {
      text-align: center;
      margin: 0 auto;
      max-width: 240px;
      padding: $grid-gutter-width/2 0;
    }

    &__icon {
      display: flex;
      align-items: center;
      margin-bottom: $grid-gutter-width;

      ::v-deep .vb-icon {
        margin: auto;

        svg {
          width: auto;
          height: 30px;
        }
      }
    }

    &__title {
      @include font-primary-semibold;
      margin-top: 0;
    }

    &__text {
      font-size: 0.8125rem;
      margin-top: 1rem;
    }

    ::v-deep .row {
      justify-content: center;

      @include media-breakpoint-up(lg) {
        justify-content: space-between;

        & > * {
          flex: 1;
          max-width: none;
        }

        .cms-text-columns__item {
          max-width: 80%;
        }
      }
    }
  }
</style>
